import React from 'react';

export const settings = {
    isStaff: true
};

export const SettingsContext = React.createContext(settings);

export const ApplicationStatusContext = React.createContext();
